import { Button } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { acceptTermsAndConditions, getTermsAndConditions, getUserInfo } from 'redux/reducers/authenticationSlice';
import landing from 'assets/img/landing.png';
import styles from './TermsAndConditionsPage.module.less';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Spin } from 'antd';
import InnerHTML from 'dangerously-set-html-content';

export default function TermsAndConditionsPage() {
	const { t } = useTranslation();
	const [termsAndConditions, setTermsAndConditions] = useState('');
	const [isLoading, setIsLoading] = useState(true);
	const dispatch = useDispatch();
	const history = useHistory();
	const getCurrentTermsAndConditions = async () => {
		setIsLoading(true);
		const result = await dispatch(getTermsAndConditions());
		//@ts-ignore
		if (getTermsAndConditions.fulfilled.match(result)) {
			setTermsAndConditions(result?.payload?.template || '');
		}
		setIsLoading(false);
	};
	const dispatchAcceptTermsAndConditions = async () => {
		const result = await dispatch(acceptTermsAndConditions());
		//@ts-ignore
		if (acceptTermsAndConditions.fulfilled.match(result)) {
			await dispatch(getUserInfo());
			history.push('/initial-setup');
		}
	};

	useEffect(() => {
		if (!termsAndConditions) {
			getCurrentTermsAndConditions();
		}
	}, [termsAndConditions]);

	if (isLoading) return <Spin />;

	return (
		<>
			<div className={styles.termsAndConditions}>
				<div className={styles.termsAndConditionsLogo}>
					<img src={landing} alt="logo" />
				</div>
				<InnerHTML className={styles.termsAndConditionsWrapper} html={termsAndConditions} />
				<Button
					data-testid="submit-btn"
					loading={false}
					type="primary"
					htmlType="submit"
					size="large"
					onClick={dispatchAcceptTermsAndConditions}
				>
					{t('TermsAndConditionsPage.AcceptAndContinue')}
				</Button>
			</div>
		</>
	);
}
